var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22787 0.139884C8.08053 0.0865405 7.91922 0.0865405 7.77187 0.139884L0.842529 2.65988L7.99987 5.38654L15.1572 2.65988L8.22787 0.139884Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 7.55948V15.9001L15.5613 13.3935C15.8246 13.2975 15.9999 13.0468 15.9999 12.7668V4.76614L8.99988 7.55948Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7668C0 13.0468 0.175344 13.2975 0.438656 13.3935L7 15.9001V7.55948L0 4.76614V12.7668Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouses);
export default __webpack_public_path__ + "static/media/warehouses.c874298e.svg";
export { ForwardRef as ReactComponent };